// extracted by mini-css-extract-plugin
export var webPresence = "web-presence-module--web-presence--2rL9Z";